import { GlobalContext } from "contexts/GlobalContext";
import { Page } from "./Page";
import { Fragment, useContext, useEffect } from "react";
import { GamesList } from "components/GamesList";

const HomePage = () => {
    const { commonData, tooltipGameFalse, tooltipGameTrue, tooltipAnalysisMissing, selectedGame, setAnalysis } =
        useContext(GlobalContext);

    useEffect(() => {
        setAnalysis(undefined);
    }, [setAnalysis]);

    return (
        <Page>
            <div className="container">
                {commonData ? (
                    <Fragment>
                        <div className="nav nav-tabs d-none">
                            <button
                                type="button"
                                ref={tooltipGameFalse}
                                className="nav-link active"
                                data-bs-toggle="tab"
                                data-bs-target="#tab-game-none"
                            >
                                Tab game false
                            </button>

                            <button
                                type="button"
                                ref={tooltipGameTrue}
                                className="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#tab-game-true"
                            >
                                Tab game true
                            </button>
                        </div>

                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="tab-game-none">
                                <GamesList />
                            </div>

                            <div className="tab-pane fade" id="tab-game-true">
                                {selectedGame && (
                                    <div className="vstack gap-4">
                                        <div className="nav nav-tabs d-none">
                                            <button
                                                type="button"
                                                ref={tooltipAnalysisMissing}
                                                className="nav-link active"
                                                data-bs-toggle="tab"
                                                data-bs-target="#tab-analysis-missing"
                                            >
                                                Analysis missing
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <div className="hstack justify-content-center gap-2">
                        <button type="button" className="btn btn-primary placeholder icon-link" disabled={true}>
                            <span className="fa fa-spin fa-spinner"></span>
                            Loading games
                        </button>
                    </div>
                )}
            </div>
        </Page>
    );
};

export default HomePage;
